import { createBrowserRouter } from "react-router-dom";
import HomeLayout from "../layouts/HomeLayout";
import ToolLayout from "../layouts/ToolLayout";
import HomePage from "../pages/home/HomePage";
import ElImageViewerPage from "../pages/ElImageViewer/ElImageViewerPage";
import LoggedInPage from "../pages/LoggedInPage";
import ProtectedRoute from "../layouts/ProtectedRoute";
import ElDefectTrackingPage from "../pages/ElDefectTracking/ElDefectTrackingPage";
import CellPage from "../pages/Cell/CellPage";
import SiliconPage from "../pages/Silicon/SiliconPage";
import CrossConnectionPage from "../pages/CrossConnection/CrossConnectionPage";
import QClassification from "../pages/QClassification/QClassification";
import PottingPage from "../pages/Potting/PottingPage";
import GlassLoaderOnePage, {
  loader as glassLoaderOne,
} from "../pages/GlassLoader/GlassLoaderOnePage";
import GlassLoaderTwoPage, {
  loader as glassLoaderTwo,
} from "../pages/GlassLoader/GlassLoaderTwoPage";
import FoilCutterOnePage, {
  loader as foilCutterOneLoader,
} from "../pages/FoilCutter1/FoilCutterOnePage";
import FoilCutterTwoPage, {
  loader as foilCutterTwoLoader,
} from "../pages/FoilCutter1/FoilCutterTwoPage";
import StringPeelPage, {
  loader as stringPeelLoader,
} from "../pages/StringPeel/StringPeelPage";
import FoilPeelTestPage, {
  loader as foilPeelLoader,
} from "../pages/FoilPeel/FoilPeelPage";
import PreLamiElCellYield from "../pages/ElDefectTracking/PreLamiElCellYieldPage";
import { fetchCellLoader } from "../services/CellService";
import { fetchSiliconLoader } from "../services/siliconService";

export const router = createBrowserRouter([
  {
    path: "/logged-in",
    element: <LoggedInPage />,
  },
  {
    path: "/",
    children: [
      {
        element: (
          <ProtectedRoute>
            <HomeLayout />
          </ProtectedRoute>
        ),
        children: [{ index: true, element: <HomePage /> }],
      },
      {
        element: (
          <ProtectedRoute>
            <ToolLayout />
          </ProtectedRoute>
        ),
        children: [
          {
            path: "q-classification",
            element: <QClassification />,
            loader: () => ({ title: "QClient" }),
          },
          {
            path: "el-images",
            element: <ElImageViewerPage />,
            loader: () => ({ title: "El-Image" }),
          },
          {
            path: "potting",
            element: <PottingPage />,
            loader: () => ({ title: "Potting" }),
          },
          {
            path: "stringer",
            element: <ElDefectTrackingPage />,
            loader: () => ({ title: "Stringer" }),
          },
          {
            path: "foil-cutter-1",
            element: <FoilCutterOnePage />,
            loader: foilCutterOneLoader,
          },
          {
            path: "foil-cutter-2",
            element: <FoilCutterTwoPage />,
            loader: foilCutterTwoLoader,
          },
          {
            path: "cell",
            element: <CellPage />,
            loader: fetchCellLoader,
          },
          {
            path: "silicon",
            element: <SiliconPage />,
            loader: fetchSiliconLoader,
          },
          {
            path: "cross-connection",
            element: <CrossConnectionPage />,
            loader: () => ({ title: "Cross-Connection" }),
          },
          {
            path: "glass-loader-1",
            element: <GlassLoaderOnePage />,
            loader: glassLoaderOne,
          },
          {
            path: "glass-loader-2",
            element: <GlassLoaderTwoPage />,
            loader: glassLoaderTwo,
          },
          {
            path: "string-peel",
            element: <StringPeelPage />,
            loader: stringPeelLoader,
          },
          {
            path: "foil-peel",
            element: <FoilPeelTestPage />,
            loader: foilPeelLoader,
          },
          {
            path: "prelami",
            element: <PreLamiElCellYield />,
            loader: () => ({ title: "Pre-Lami El-CellYield" }),
          },
        ],
      },
    ],
  },
]);
